import React from "react";
import "./Homepage.css";
import mainLogo from "../../Images/MainLogo.png";
import "../../Components/CoolButton/CoolButton.css";
import packageJson from '../../../package.json'
import { useClipTheme } from "../../features/clips/hooks/useClipTheme";

function Homepage() {
  const { theme } = useClipTheme();

  return (
    <div className="MainContainer" data-home-theme={theme}>
      <img
        alt="h"
        id="Welcome_Load"
        className="growAnimation hoverAnimation"
        src={mainLogo}
        style={{ animationFillMode: "forwards" }}
      />
      <div className="ellipse"></div>
      <footer><p className="version"><b>V{packageJson.version}</b></p></footer>
    </div>
  );
}

export default Homepage;
